<template>
    <div
        class="match-details__stats-container"
        v-show="!isShowNoData && !isSkeletonLoading.matchStat"
    >
        <!--  && !isSkeletonLoading.matchStat -->
        <div class="match-detail__stats-header-title">
            {{ $t("MATCH_STATS") }}
        </div>
        <div class="match-detail__head-icon">
            <Navigation
                :id="matchDetailScore.homeTeamId"
                :category="'team'"
                :name="matchDetailScore.homeTeamName"
            >
                <Icon
                    :logoUrl="matchDetailScore.homeLogo"
                    hasClass="match-detail-team-icon"
                ></Icon>
            </Navigation>
            <div v-show="!isMobile">{{ $t("HEAD_TO_HEAD") }}</div>
            <div v-show="isMobile">{{ $t("H2H") }}</div>
            <Navigation
                :id="matchDetailScore.awayTeamId"
                :category="'team'"
                :name="matchDetailScore.awayTeamName"
            >
                <Icon
                    :logoUrl="matchDetailScore.awayLogo"
                    hasClass="match-detail-team-icon"
                ></Icon>
            </Navigation>
        </div>
        <div class="played-list">
            <!-- PLAYED -->
            <div>
                <div class="match-detail__stats-card">
                    <div class="display-flex-center w-100 played-container">
                        <!-- {{
            h2hStat
          }} -->
                        <div class="w-100 played-box">
                            <div
                                class="match-detail__stats-number total-wins-container display-flex-sb w-100"
                            >
                                <div v-show="!isMobile">
                                    {{
                                        h2hStat.homeTotalWins
                                            ? h2hStat.homeTotalWins
                                            : "-"
                                    }}
                                </div>
                                <div class="total-wins-text" v-show="!isMobile">
                                    {{ $t("TOTAL_WINS") }}
                                </div>
                                <div
                                    class="total-wins-text played-win-text"
                                    v-show="isMobile"
                                >
                                    {{ $t("WINS") }}
                                </div>
                            </div>
                            <div class="match-detail__stats-container">
                                <div
                                    class="match-detail__stats-number played-win-score"
                                    v-show="isMobile"
                                >
                                    {{
                                        h2hStat.homeTotalWins
                                            ? h2hStat.homeTotalWins
                                            : "-"
                                    }}
                                </div>
                                <div
                                    class="match-detail__stats-container mr-05rem"
                                >
                                    <div
                                        class="match-detail__stats-progress-wrapper"
                                    >
                                        <div
                                            class="match-detail__stats-progress-bar"
                                            :style="{
                                                borderRadius: isMobile
                                                    ? '8px'
                                                    : (parseFloat(
                                                          h2hStat.homeTotalWins
                                                      ) /
                                                          (parseFloat(
                                                              h2hStat.homeTotalWins
                                                          ) +
                                                              parseFloat(
                                                                  h2hStat.awayTotalWins
                                                              ))) *
                                                          100 ===
                                                          0 ||
                                                      (parseFloat(
                                                          h2hStat.homeTotalWins
                                                      ) /
                                                          (parseFloat(
                                                              h2hStat.homeTotalWins
                                                          ) +
                                                              parseFloat(
                                                                  h2hStat.awayTotalWins
                                                              ))) *
                                                          100 >
                                                          98
                                                    ? '8px'
                                                    : '0 8px 8px 0',
                                                width:
                                                    h2hStat.homeTotalWins < 0
                                                        ? 0
                                                        : (parseFloat(
                                                              h2hStat.homeTotalWins
                                                          ) /
                                                              (parseFloat(
                                                                  h2hStat.homeTotalWins
                                                              ) +
                                                                  parseFloat(
                                                                      h2hStat.awayTotalWins
                                                                  ))) *
                                                              100 +
                                                          '%',
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="match-detail__stats-title played">
                            <div class="played-title">
                                {{ $t("PLAYED") }}
                            </div>
                            <div class="played-value">
                                {{ h2hStat.totalPlays }}
                            </div>
                            <div class="played-draws-value">
                                {{ $t("DRAWS") }}
                                {{ h2hStat.totalDraws }}
                            </div>
                        </div>

                        <div class="w-100 played-box">
                            <div
                                class="w-100 match-detail__stats-number total-wins-container right display-flex-sb w-100"
                            >
                                <div class="total-wins-text" v-show="!isMobile">
                                    {{ $t("TOTAL_WINS") }}
                                </div>
                                <div
                                    class="total-wins-text right played-win-text"
                                    v-show="isMobile"
                                >
                                    {{ $t("WINS") }}
                                </div>
                                <!-- match-detail__stats-number -->
                                <div class="" v-show="!isMobile">
                                    {{
                                        h2hStat.awayTotalWins
                                            ? h2hStat.awayTotalWins
                                            : "-"
                                    }}
                                </div>
                            </div>
                            <div class="match-detail__stats-container">
                                <div
                                    class="match-detail__stats-progress-wrapper right"
                                >
                                    <div
                                        class="match-detail__stats-progress-bar"
                                        :style="{
                                            borderRadius: isMobile
                                                ? '8px'
                                                : (parseFloat(
                                                      h2hStat.awayTotalWins
                                                  ) /
                                                      (parseFloat(
                                                          h2hStat.awayTotalWins
                                                      ) +
                                                          parseFloat(
                                                              h2hStat.homeTotalWins
                                                          ))) *
                                                      100 ===
                                                      0 ||
                                                  (parseFloat(
                                                      h2hStat.awayTotalWins
                                                  ) /
                                                      (parseFloat(
                                                          h2hStat.awayTotalWins
                                                      ) +
                                                          parseFloat(
                                                              h2hStat.homeTotalWins
                                                          ))) *
                                                      100 >
                                                      98
                                                ? '8px'
                                                : '8px 0 0 8px',
                                            width:
                                                h2hStat.awayTotalWins < 0
                                                    ? 0
                                                    : (parseFloat(
                                                          h2hStat.awayTotalWins
                                                      ) /
                                                          (parseFloat(
                                                              h2hStat.awayTotalWins
                                                          ) +
                                                              parseFloat(
                                                                  h2hStat.homeTotalWins
                                                              ))) *
                                                          100 +
                                                      '%',
                                        }"
                                    ></div>
                                </div>
                                <div
                                    class="match-detail__stats-number played-win-score right-text"
                                    v-show="isMobile"
                                >
                                    {{
                                        h2hStat.awayTotalWins
                                            ? h2hStat.awayTotalWins
                                            : "-"
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Home wins -->
            <div>
                <div class="match-detail__stats-card">
                    <div class="display-flex-center w-100 wins-container">
                        <div class="w-100">
                            <div
                                class="match-detail__stats-number h2h display-flex-sb w-100"
                            >
                                <div>
                                    {{
                                        h2hStat.homeHomeWins
                                            ? h2hStat.homeHomeWins
                                            : "-"
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="match-detail__stats-title wins-title">
                            <div class="played-title">
                                {{ $t("HOME_WINS") }}
                            </div>
                        </div>
                        <div class="w-100">
                            <div
                                class="w-100 match-detail__stats-number h2h right display-flex-align-fe w-100"
                            >
                                {{
                                    h2hStat.homeAwayWins
                                        ? h2hStat.homeAwayWins
                                        : "-"
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Away wins -->
            <div>
                <div class="match-detail__stats-card">
                    <div class="display-flex-center w-100 wins-container">
                        <div class="w-100">
                            <div
                                class="match-detail__stats-number h2h display-flex-sb w-100"
                            >
                                <div>
                                    {{
                                        h2hStat.awayHomeWins
                                            ? h2hStat.awayHomeWins
                                            : "-"
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="match-detail__stats-title wins-title">
                            <div class="played-title">
                                {{ $t("AWAY_WINS") }}
                            </div>
                        </div>
                        <div class="w-100">
                            <div
                                class="w-100 match-detail__stats-number h2h right display-flex-align-fe w-100"
                            >
                                {{
                                    h2hStat.awayAwayWins
                                        ? h2hStat.awayAwayWins
                                        : "-"
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- MATCH STATICTIS -->
    <div class="match-details__stats-container" v-show="!isShowNoData">
        <div class="match-detail__stats-wrapper">
            <div class="match-detail__stats-header">
                {{ $t("MATCH_STATISTICS") }}
            </div>
            <div
                v-for="(o, index) in stateList"
                :key="index"
                v-show="!isLoading && !isShowNoData"
            >
                <div
                    class="match-detail__stats-card"
                    v-if="o.homeScore !== null && o.awayScore !== null"
                >
                    <div
                        class="display-flex-center w-100 match-detail__stats-item-box"
                    >
                        <div class="w-100 dashed-box">
                            <div class="match-detail__stats-number">
                                {{ o.homeScore }}
                            </div>
                            <div class="match-detail__stats-container">
                                <div
                                    class="match-detail__stats-container mr-05rem"
                                >
                                    <div
                                        class="match-detail__stats-progress-wrapper"
                                    >
                                        <div
                                            class="match-detail__stats-progress-bar"
                                            :style="{
                                                borderRadius: isMobile
                                                    ? '8px'
                                                    : (parseFloat(o.homeScore) /
                                                          (parseFloat(
                                                              o.homeScore
                                                          ) +
                                                              parseFloat(
                                                                  o.awayScore
                                                              ))) *
                                                          100 ===
                                                          0 ||
                                                      (parseFloat(o.homeScore) /
                                                          (parseFloat(
                                                              o.homeScore
                                                          ) +
                                                              parseFloat(
                                                                  o.awayScore
                                                              ))) *
                                                          100 >
                                                          98
                                                    ? '8px'
                                                    : '0 8px 8px 0',
                                                width:
                                                    (parseFloat(o.homeScore) /
                                                        (parseFloat(
                                                            o.homeScore
                                                        ) +
                                                            parseFloat(
                                                                o.awayScore
                                                            ))) *
                                                        100 +
                                                    '%',
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="match-detail__stats-title dashed-box">
                            {{ $t(o.title) }}
                        </div>

                        <div
                            class="w-100 dashed-box match-detail__stats-item-box right"
                        >
                            <div class="w-100 match-detail__stats-number right">
                                {{ o.awayScore }}
                            </div>
                            <div class="match-detail__stats-container">
                                <div
                                    class="match-detail__stats-progress-wrapper right"
                                >
                                    <div
                                        class="match-detail__stats-progress-bar"
                                        :style="{
                                            borderRadius: isMobile
                                                ? '8px'
                                                : (parseFloat(o.homeScore) /
                                                      (parseFloat(o.homeScore) +
                                                          parseFloat(
                                                              o.awayScore
                                                          ))) *
                                                      100 ===
                                                      0 ||
                                                  (parseFloat(o.homeScore) /
                                                      (parseFloat(o.homeScore) +
                                                          parseFloat(
                                                              o.awayScore
                                                          ))) *
                                                      100 >
                                                      98
                                                ? '8px'
                                                : '8px 0 0 8px',
                                            width:
                                                (parseFloat(o.awayScore) /
                                                    (parseFloat(o.homeScore) +
                                                        parseFloat(
                                                            o.awayScore
                                                        ))) *
                                                    100 +
                                                '%',
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Loading v-show="isLoading"></Loading> -->
        <!--  && !isLoading -->
        <!-- <NoData v-show="isShowNoData && !isSkeletonLoading.matchStat"
      text="NO_STATS"
      class="mt-15rem" /> -->
    </div>

    <!-- <GeneralContentSkeleton v-show="isSkeletonLoading.matchStat"></GeneralContentSkeleton> -->
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import GeneralContentSkeleton from "@/components/skeletonLoading/GeneralContentSkeleton.vue";

export default {
    components: {
        GeneralContentSkeleton,
    },
    data() {
        return {
            isShowNoData: true,
            isLoading: false,
            matchId: "",
            stateList: [],
            footballStateList: [
                {
                    title: "SHOTS_TOTAL",
                    id: "shotsTotal",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SHOTS_ON_GOAL",
                    id: "shotsOngoal",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SHOTS_OFF_GOAL",
                    id: "shotsOffgoal",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SHOTS_BLOCKED",
                    id: "shotsBlocked",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SHOTS_INSIDE_BOX",
                    id: "shotsInsidebox",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SHOTS_OUTSIDE_BOX",
                    id: "shotsOutsidebox",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "FOULS",
                    id: "fouls",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "CORNER",
                    id: "corners",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "OFFSIDES",
                    id: "offsides",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "POSSESSION_TIME",
                    id: "possestiontime",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "YELLOW_CARDS",
                    id: "yellowcards",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "RED_CARDS",
                    id: "redcards",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "SAVES",
                    id: "saves",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "PASSES_TOTAL",
                    id: "passesTotal",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "PASSES_ACCURATE",
                    id: "passesAccurate",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "PASSED_PERCENTAGE",
                    id: "passesPct",
                    homeScore: null,
                    awayScore: null,
                },
            ],
            basketballStateList: [
                {
                    title: "FIELD_GOAL_PERCENTAGE",
                    id: "fgPct",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "THREE_POINT_PERCENTAGE",
                    id: "tptPct",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "FREE_THROW_PERCENTAGE",
                    id: "ftPct",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "REBOUNDS",
                    id: "rebounds",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "ASSISTS",
                    id: "assists",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "BLOCKS",
                    id: "blocks",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "TURNOVERS",
                    id: "turnonvers",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "STEALS",
                    id: "steals",
                    homeScore: null,
                    awayScore: null,
                },
                {
                    title: "FOULS",
                    id: "fouls",
                    homeScore: null,
                    awayScore: null,
                },
            ],
            matchDetailStatesLeft: {},
            matchDetailStatesRight: {},
            isSkeletonLoading: {
                matchStat: false,
            },
            isNoData: 0,
            h2hStat: {},
        };
    },
    props: {
        matchDetailScore: Object,
    },
    created() {
        this.matchId = this.$route.params.matchId;
    },
    beforeUnmount() {
        this.stateList = [];
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "currentSportType",
            "manualRefreshMatchDetail",
        ]),
    },
    watch: {
        manualRefreshMatchDetail: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.getMatchDetailStatData();
                    this.getMatchDetailsH2HStatData();
                }
            },
        },
        currentSportType: {
            handler(newVal, oldVal) {
                if (newVal) this.getMatchDetailStatData();
                this.getMatchDetailsH2HStatData();
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.getMatchDetailStatData();
            this.getMatchDetailsH2HStatData();
        });
    },
    methods: {
        ...mapMutations(["MANUAL_REFRESH_MATCH_DETAIL"]),
        ...mapActions([
            "getMatchDetailStat",
            "getBasketballMatchDetailStat",
            "manualRefreshMatchDetail",
            "getMatchDetailsH2HStat",
        ]),

        async getMatchDetailStatData() {
            // this.isLoading = true;
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.matchStat = true;
            }
            let apiCall;
            if (this.currentSportType === "football")
                apiCall = this.getMatchDetailStat;
            else if (this.currentSportType === "basketball")
                apiCall = this.getBasketballMatchDetailStat;
            const result = await apiCall({ matchId: this.matchId });
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.matchStat = false;
                this.verifyIfAllAPICallsDone();
            }
            // this.isLoading = false;

            if (result.result.length === 0) {
                this.isShowNoData = true;
            } else {
                this.isShowNoData = false;
                let homeResult;
                let awayResult;
                let gg = this.stateList;

                if (this.currentSportType === "football") {
                    homeResult = result.result[0];
                    awayResult = result.result[1];
                    this.footballStatCase(homeResult, awayResult);
                } else if (this.currentSportType === "basketball") {
                    homeResult = result.result.home;
                    awayResult = result.result.away;
                    this.basketballStatCase(homeResult, awayResult);
                }

                if (this.isNoData == this.stateList.length) {
                    this.isShowNoData = true;
                }
            }
        },
        footballStatCase(homeResult, awayResult) {
            this.isNoData = 0;
            for (let i = 0; i < this.footballStateList.length; i++) {
                switch (this.footballStateList[i].id) {
                    case "shotsTotal":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsTotal;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsTotal;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "shotsOngoal":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsOngoal;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsOngoal;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "shotsOffgoal":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsOffgoal;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsOffgoal;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "shotsBlocked":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsBlocked;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsBlocked;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "shotsInsidebox":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsInsidebox;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsInsidebox;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "shotsOutsidebox":
                        this.footballStateList[i].homeScore =
                            homeResult.shotsOutsidebox;
                        this.footballStateList[i].awayScore =
                            awayResult.shotsOutsidebox;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "fouls":
                        this.footballStateList[i].homeScore = homeResult.fouls;
                        this.footballStateList[i].awayScore = awayResult.fouls;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "corners":
                        this.footballStateList[i].homeScore =
                            homeResult.corners;
                        this.footballStateList[i].awayScore =
                            awayResult.corners;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "offsides":
                        this.footballStateList[i].homeScore =
                            homeResult.offsides;
                        this.footballStateList[i].awayScore =
                            awayResult.offsides;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "possestiontime":
                        this.footballStateList[i].homeScore =
                            homeResult.possestiontime;
                        this.footballStateList[i].awayScore =
                            awayResult.possestiontime;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "yellowcards":
                        this.footballStateList[i].homeScore =
                            homeResult.yellowcards;
                        this.footballStateList[i].awayScore =
                            awayResult.yellowcards;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "redcards":
                        this.footballStateList[i].homeScore =
                            homeResult.redcards;
                        this.footballStateList[i].awayScore =
                            awayResult.redcards;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "saves":
                        this.footballStateList[i].homeScore = homeResult.saves;
                        this.footballStateList[i].awayScore = awayResult.saves;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "passesTotal":
                        this.footballStateList[i].homeScore =
                            homeResult.passesTotal;
                        this.footballStateList[i].awayScore =
                            awayResult.passesTotal;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "passesAccurate":
                        this.footballStateList[i].homeScore =
                            homeResult.passesAccurate;
                        this.footballStateList[i].awayScore =
                            awayResult.passesAccurate;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "passesPct":
                        this.footballStateList[i].homeScore =
                            homeResult.passesPct;
                        this.footballStateList[i].awayScore =
                            awayResult.passesPct;
                        if (
                            this.footballStateList[i].homeScore == null &&
                            this.footballStateList[i].awayScore == null
                        ) {
                            this.isNoData++;
                        }
                        break;
                }
            }
            this.stateList = [...this.footballStateList];
        },
        basketballStatCase(homeResult, awayResult) {
            this.isNoData = 0;
            for (let i = 0; i < this.basketballStateList.length; i++) {
                switch (this.basketballStateList[i].id) {
                    case "fgPct":
                        this.basketballStateList[i].homeScore =
                            homeResult.fgPct;
                        this.basketballStateList[i].awayScore =
                            awayResult.fgPct;
                        if (
                            this.basketballStateList[i].homeScore == "0.0" &&
                            this.basketballStateList[i].awayScore == "0.0"
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "tptPct":
                        this.basketballStateList[i].homeScore =
                            homeResult.tptPct;
                        this.basketballStateList[i].awayScore =
                            awayResult.tptPct;
                        if (
                            this.basketballStateList[i].homeScore == "0.0" &&
                            this.basketballStateList[i].awayScore == "0.0"
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "ftPct":
                        this.basketballStateList[i].homeScore =
                            homeResult.ftPct;
                        this.basketballStateList[i].awayScore =
                            awayResult.ftPct;
                        if (
                            this.basketballStateList[i].homeScore == "0.0" &&
                            this.basketballStateList[i].awayScore == "0.0"
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "rebounds":
                        this.basketballStateList[i].homeScore =
                            homeResult.rebounds;
                        this.basketballStateList[i].awayScore =
                            awayResult.rebounds;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "assists":
                        this.basketballStateList[i].homeScore =
                            homeResult.assists;
                        this.basketballStateList[i].awayScore =
                            awayResult.assists;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "blocks":
                        this.basketballStateList[i].homeScore =
                            homeResult.blocks;
                        this.basketballStateList[i].awayScore =
                            awayResult.blocks;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "turnonvers":
                        this.basketballStateList[i].homeScore =
                            homeResult.turnonvers;
                        this.basketballStateList[i].awayScore =
                            awayResult.turnonvers;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "steals":
                        this.basketballStateList[i].homeScore =
                            homeResult.steals;
                        this.basketballStateList[i].awayScore =
                            awayResult.steals;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                    case "fouls":
                        this.basketballStateList[i].homeScore =
                            homeResult.fouls;
                        this.basketballStateList[i].awayScore =
                            awayResult.fouls;
                        if (
                            this.basketballStateList[i].homeScore == 0 &&
                            this.basketballStateList[i].awayScore == 0
                        ) {
                            this.isNoData++;
                        }
                        break;
                }
            }
            this.stateList = [...this.basketballStateList];
        },
        getStateList() {
            //  this.statesList
        },
        verifyIfAllAPICallsDone() {
            if (!this.isSkeletonLoading.nextFiveMatch) {
                this.MANUAL_REFRESH_MATCH_DETAIL();
            }
        },
        async getMatchDetailsH2HStatData() {
            const result = await this.getMatchDetailsH2HStat({
                matchId: this.matchId,
            });
            if (result.errorCode === 0) {
                this.h2hStat = result.result;
            }
        },
    },
};
</script>

<style scoped>
.match-detail__stats-wrapper {
    margin: 0 auto;
}
.match-detail__stats-header-title {
    padding: 0 0 1rem 0;
    /* margin: 0 1rem; */
    text-align: left;
    font-family: var(--weight-600);
    font-size: 20px;
    color: var(--color-text-default-default);
}
.match-detail__stats-header {
    padding: 0 0 16px 0;
    /* margin: 0 1rem; */
    text-align: left;
    text-align: center;
    font-size: 32px;
    line-height: 120%;
    /* margin-top: 24px; */
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
}
.match-detail__stats-card {
    margin: 0 1rem;
    color: var(--color-text-default-default);
    margin: 0 0 1rem 0;
}
.match-detail__stats-container {
    display: flex;
    width: 50%;
    margin-right: 0.5rem;
    font-size: 11.2px;
    align-items: center;
    width: 100%;
}
.match-detail__stats-container:last-of-type {
    margin-right: 0;
}
.match-detail__stats-title {
    font-size: var(--typography-caption-size-large);
    width: 88px;
    padding: 16px;
    letter-spacing: 0.24px;
    flex-shrink: 0;
    min-height: 52.8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: 0.2px;
}
.match-detail__stats-title.dashed-box {
    padding: 16px;
}

@media (min-width: 768px){
    /* .match-detail__stats-wrapper {
    width: 70%;
  } */
}
</style>

<style scoped>
.match-detail__head-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 166.67px;
    margin-bottom: 16px;
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
    font-size: 32px;
    line-height: 120%;
    color: var(--color-text-default-default);
}
.match-detail-team-icon {
    width: 66.66px;
}

.match-detail__stats-title.played {
    display: block;
    color: var(--color-text-default-default);
    padding: 8px 16px;
}
.match-detail__stats-title.played .played-title {
    font-size: var(--typography-heading-size-extra-small);
    font-family: var(--weight-700);
    color: var(--color-text-default-default);
}
.match-detail__stats-title.played .played-value {
    font-size: var(--typography-heading-size-medium);
    font-family: var(--weight-600);
    letter-spacing: -0.64px;
    line-height: 120%;
    padding: 4px 0;
}
.match-detail__stats-title.played .played-draws-value {
    color: var(--color-text-default-secondary);
    font-size: var(--typography-body-size-small);
    letter-spacing: 0.64px;
}
.played-win-score {
    width: 40px;
    flex-shrink: 0;
    text-align: center;
}
.match-detail__stats-number {
    /* margin-right: 0.5rem; */
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    font-size: 14px;
    letter-spacing: 0.64px;
}
.match-detail__stats-number.right {
    margin-right: 0;
    text-align: right;
}
.match-detail__stats-number.h2h {
    /* padding-left: 8px; */
    /* width: 40px; */
    display: flex;
    align-items: center;
    justify-content: left;
    flex-shrink: 0;
}
.match-detail__stats-number.h2h.right {
    /* padding-left: 0; */
    /* padding-right: 8px; */
    justify-content: right;
}
.match-detail__stats-progress-wrapper {
    height: 1rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: var(--color-bar-background);
    border-radius: var(--size-radius-200);
}
.match-detail__stats-progress-wrapper.right {
    justify-content: flex-start;
}
.match-detail__stats-progress-bar {
    height: 100%;
    width: 0;
    background-color: var(--success-500);
    border-radius: var(--size-radius-200) 0 0 var(--size-radius-200);
}
.match-detail__stats-progress-wrapper.right .match-detail__stats-progress-bar {
    background-color: var(--secondary-400);
}
.dashed-box {
    border: 1px dotted var(--color-border-default-default);
    padding: 7px 8px 7px 0;
    box-sizing: border-box;
}
.dashed-box.right {
    padding: 7px 0 7px 8px;
}
.dashed-box:nth-child(1) {
    border-left: 0;
}
.dashed-box:nth-child(2) {
    border-left: 0;
    border-right: 0;
}
.dashed-box:nth-child(3) {
    border-right: 0;
}
.played-list .match-detail__stats-card {
    margin-bottom: 0;
}
.played-list > div:last-child .match-detail__stats-card .wins-container {
    border-bottom: 0;
}
.wins-container {
    border-bottom: 1px dotted var(--color-border-default-default);
    padding: 0 4px;
    box-sizing: border-box;
}
.played-container {
    border-bottom: 1px dotted var(--color-border-default-default);
    color: var(--color-text-default-default);
}
.wins-title {
    width: auto;
    font-size: var(--typography-body-size-large);
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    min-height: unset;
    padding: 4px 16px;
    letter-spacing: 0.64px;
}
.total-wins-container {
    margin-bottom: 7.5px;
    font-size: 16px;
    letter-spacing: 0.64px;
}
.total-wins-text {
    font-size: 16px;
    font-family: var(--weight-400);
    color: var(--color-text-default-secondary);
    letter-spacing: 0.64px;
    width: 50%;
    text-align: right;
}
.total-wins-container.right .total-wins-text {
    /* margin-left: auto; */
    text-align: left;
}
.match-detail__stats-wrapper .match-detail__stats-card .dashed-box {
    height: 52.8px;
    min-height: auto;
}
.match-detail__stats-wrapper .match-detail__stats-title {
    font-family: var(--weight-700);
    color: var(--color-text-default-secondary);
}

.match-details__stats-container {
    margin-bottom: 48px;
}

@media(max-width: 768px) {
    /* for test */
    .match-details__stats-container {
        background-color: var(--color-background-default-secondary);
        border-radius: 8px;
        /* margin-top: 16px; */
        padding: 16px;
        margin-bottom: 16px;
    }
    .match-detail__content-container {
        background-color: var(--white-1000) !important;
    }
    .match-detail__stats-header-title {
        display: none;
    }
    .match-detail-team-icon {
        display: none;
    }
    .match-detail__head-icon {
        font-size: 24px;
        padding-top: 16px;
        letter-spacing: -0.64px;
        font-family: var(--weight-600);
    }
    .match-detail__stats-title.played .played-title {
        font-size: 13px;
        letter-spacing: 0.64px;
        font-family: var(--weight-400);
    }
    .match-detail__stats-title.played .played-value {
        font-size: 16px;
        letter-spacing: 0.64px;
    }
    .played-draws-value {
        color: var(--color-text-default-secondary);
    }
    .match-detail__stats-number.right-text {
        margin-left: 0.5rem;
        margin-right: 0;
    }
    .played-box {
        margin-bottom: 20px;
    }
    .match-detail__head-icon {
        padding: 0;
        justify-content: center;
    }
    .wins-title {
        padding: 8px 16px;
    }
    .wins-container {
        padding: 0;
    }
    .match-detail__stats-header {
        margin-top: 0;
        font-size: 24px;
        letter-spacing: -0.64px;
        font-family: var(--weight-600);
    }
    .dashed-box {
        border: 0;
    }
    .match-detail__stats-item-box {
        position: relative;
    }
    .match-detail__stats-number {
        font-size: 16px;
        letter-spacing: 0.64px;
        font-family: var(--weight-600);
    }
    .match-detail__stats-item-box .match-detail__stats-title {
        position: absolute;
        top: -8.5px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        font-size: 16px;
        color: var(--color-text-default-default);
        font-family: var(--weight-700);
        height: auto;
        width: 80%;
        letter-spacing: 0.64px;
    }
    .match-detail__stats-item-box .match-detail__stats-number {
        margin-bottom: 8px;
        font-family: var(--weight-600);
    }
    .match-detail__stats-item-box .dashed-box {
        padding: 7px;
    }
    .match-detail__stats-item-box .dashed-box:first-child {
        padding-right: 4px;
    }
    .match-detail__stats-item-box .dashed-box:last-child {
        padding-left: 4px;
    }
    .match-detail__stats-progress-wrapper {
        height: 12px;
    }
    .match-detail__stats-progress-bar {
    }
    .total-wins-text {
        text-align: center;
    }
    .played-title {
        font-family: var(--weight-400);
    }
    .total-wins-text,
    .played-title,
    .match-detail__stats-number {
        font-size: 13px;
    }
    .match-detail__stats-item-box .match-detail__stats-title {
        font-family: var(--weight-400);
        font-size: 13px;
    }
    .match-detail__stats-number.h2h {
        /* padding-left: 8px; */
        width: 40px;
        justify-content: center;
    }
    .match-detail__stats-number.h2h.right {
        /* padding-left: 0; */
        /* padding-right: 8px; */
        margin-left: auto;
        justify-content: center;
    }
    .played-win-text {
        text-align: center;
        width: 40px;
    }
    .played-win-text.right {
        text-align: center;
        margin-left: auto;
    }
}
</style>
